/**
 * Canonical "now showing" titles shared by the homepage ticker and the
 * Kramer voice agent so both always agree on what's playing.
 */
export const NOW_SHOWING_TITLES = [
	"PULP FICTION",
	"THE MATRIX",
	"GOODFELLAS",
	"JURASSIC PARK",
	"HOME ALONE",
	"TITANIC",
	"THE LION KING",
	"FORREST GUMP",
	"SPEED",
	"DIE HARD",
	"TERMINATOR 2",
	"SILENCE OF THE LAMBS",
	"BRAVEHEART",
	"SEVEN",
	"THE FISHER KING",
	"PRANCER",
];
